import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  darker?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  darker = false
}: SectionProps) {
  return <section id={id} className={`
        py-20 md:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden
        ${darker ? 'bg-dark-900' : 'bg-dark-800'}
        ${className}
      `} data-id="element-102">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-103">{children}</div>
    </section>;
}
export const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};